export default __webpack_public_path__ + "static/media/bars-progress-solid.25e51b63.svg";